jQuery(function($){
	// var chartConfig = {
	// 	xValues: ["Rehearsal 9/6/2022", "Penrod Arts Fair", "Rehearsal 9/12/2022", "Rehearsal 9/19/2022", "Rehearsal 9/26/2022", "Visiting Artist Series Concert", "Rehearsal 10/3/2022", "Rehearsal 10/10/2022", "CAR/JAD District Convention - Fall 2022", "Rehearsal 10/17/2022"],
	//     yValues: [42, 37,40, 41, 43, 39, 45, 33, 30, 37],
	//     yValuesGuest: [1, 3,2, 1, 4, 3, 4, 3, 3, 3],
	// 	colors: ["#048a81", "#6875CA", "#048a81", "#048a81", "#048a81", "#6875CA", "#048a81", "#048a81", "#6875CA", "#048a81"],
	// 	urls: ["https://www.ebay.com", "https://circlecitysound.org", "#three", "#four", "#five", "https://www.ebay.com", "https://circlecitysound.org", "#three", "#four", "#five"]
	// };

	// new Chart("myChart", {
	//     type: "bar",
	//     data: {
	//         labels: chartConfig.xValues,
	//         datasets: [{
	//             label: 'Members',
	//             backgroundColor: chartConfig.colors,
	//             data: chartConfig.yValues
	//          }, {
	//             label: 'Guests',
	//             backgroundColor: '#9efaaf',
	//             data: chartConfig.yValuesGuest 
	//         }]
	//     },
	//     options: {
	//         onClick: function(event) {
	//             const index = this.getElementAtEvent(event)[0]._index;
	//             window.open(chartConfig.urls[index], "_blank");
	//         },
	//         tooltips: {
	//             displayColors: false
	//         },
	//         legend: {
	//         	display: false
	// 		},
	//         // hover: {
	// 	       //  onHover: function(e) {
	//         //     	var point = this.getElementAtEvent(e);
	//         //         if(point.length) e.target.style.cursor = 'pointer';
	//         //         else e.target.style.cursor = 'default';
	//         //     }
	//         // },
	//         title: {
	//             display: true,
	//             text: "Attendance - Most Recent 10 Events"
	//         },
	//         scales: {
	//             yAxes: [{
	//                 stacked: true,
	//                 ticks: {
	//                     beginAtZero: true
	//                 }
	//             }],
	//         }    
	//     }
	// });














});